import { useAtom } from "jotai";
import { nanoid } from "nanoid";
import { AiOutlinePlus } from "react-icons/ai";
import { ReactSortable } from "react-sortablejs";
import { fieldObjectsAtom, fieldsActionAtom } from "../state/global.state";
import { InputButton } from "./InputButton";

export const Navigations = () => {
  const [fieldObjects, setFieldObjects] = useAtom(fieldObjectsAtom);
  const [fieldsAction, setFieldsAction] = useAtom(fieldsActionAtom);

  const AddMenu = () => {
    return (
      <button
        className="w-9 h-9 bg-slate-800 text-white text-sm flex justify-center items-center gap-2 rounded-xl hover:bg-slate-900 duration-300 transition-all"
        onClick={() => {
          const new_object_id = nanoid();
          const new_object_name = "New_" + nanoid(4);
          const new_fields_id = nanoid();
          const new_object = {
            id: new_object_id,
            name: new_object_name,
            fields: [
              {
                id: new_fields_id,
                after: "",
                before: "",
                value: "",
              },
            ],
          };
          const new_objects = [...fieldObjects, new_object];
          setFieldObjects(() => new_objects);
          setFieldsAction(!fieldsAction);
        }}
      >
        <AiOutlinePlus />
      </button>
    );
  };

  return (
    <div className="flex gap-3 bg-slate-600 py-[10px] items-center px-10 -mx-5">
      <div id="nav-container" className="flex gap-3 flex-1 overflow-x-auto hide-scrollbar">
        <ReactSortable list={fieldObjects} setList={setFieldObjects} className="!hidden lg:!flex">
          {fieldObjects.length > 0 &&
            fieldObjects.map((fieldObject, index) => {
              return (
                <div key={fieldObject.id}>
                  <InputButton fieldObject={fieldObject} index={index} />
                </div>
              );
            })}
        </ReactSortable>
        <div className="flex lg:!hidden gap-2">
          {fieldObjects.length > 0 &&
            fieldObjects.map((fieldObject, index) => {
              return (
                <div key={fieldObject.id}>
                  <InputButton fieldObject={fieldObject} index={index} />
                </div>
              );
            })}
        </div>
      </div>
      <AddMenu />
    </div>
  );
};
